import SectionHeading from "@/pages/home/components/SectionHeading";
import { accessSteps } from "@/mocks/home";

export default function GuideSection() {
  return (
    <section
      id="access-guide"
      className="scroll-mt-28 py-14 md:py-20 bg-background-100 border-y border-background-200"
    >
      <div className="px-4 md:px-6">
        <SectionHeading
          eyebrow="访问教程"
          title="四步完成访问，新手也能上手"
          desc="无论用手机还是电脑，按下面的顺序操作即可；每一步都附上容易忽略的小提醒。"
        />

        <ol className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
          {accessSteps.map((step, index) => (
            <li
              key={step.id}
              className="relative flex gap-4 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200"
            >
              <div className="flex flex-col items-center shrink-0">
                <span className="w-10 h-10 rounded-full bg-primary-500 text-background-50 font-heading font-bold flex items-center justify-center">
                  {index + 1}
                </span>
                {index < accessSteps.length - 1 ? (
                  <span className="hidden md:block flex-1 w-px bg-background-300 mt-3" aria-hidden="true" />
                ) : null}
              </div>
              <div className="min-w-0">
                <h3 className="font-heading font-bold text-base text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                <p className="mt-3 inline-flex items-start gap-2 text-xs text-secondary-800 bg-secondary-100/70 rounded-md px-3 py-2 leading-relaxed">
                  <i className="ri-lightbulb-line mt-0.5 shrink-0" aria-hidden="true" />
                  {step.tip}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}